import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { RbdmTownList } from '.';

export const useRbdmTownDetailsQuery = (selectedCmdi: string | null): IQueryResponse<Array<RbdmTownList>> => {
	const fetchRbdmTownDetailsData = async (): Promise<Array<RbdmTownList>> => {
		const payload: Record<string, string> = {
			limit: '0',
		};
		if (selectedCmdi) {
			payload.cmdi_code = selectedCmdi;
		}
		const response = await APIService.getData<Array<RbdmTownList>>(APICONFIG.TOWN_LIST_DETAILS_RBDM, payload);
		return response;
	};

	const { data, error, isLoading, isPending, refetch } = useQuery({
		queryKey: ['rbdmTownList', selectedCmdi],
		queryFn: fetchRbdmTownDetailsData,
		enabled: !!selectedCmdi,
		staleTime: 30 * 60 * 1000,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
	};
};
